const STORAGE_KEY = 'portal_post_login_redirect';
const MAX_LEN = 512;

function isSafeRedirectPath(fullPath) {
  if (!fullPath || typeof fullPath !== 'string') return false;
  if (fullPath.length > MAX_LEN) return false;
  if (!fullPath.startsWith('/') || fullPath.startsWith('//')) return false;
  const pathOnly = fullPath.split(/[?#]/)[0];
  if (pathOnly.includes('..')) return false;
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(pathOnly)) return false;
  return true;
}

/**
 * ログイン後に遷移する Vue Router のパス（同一オリジン・アプリ内）を保存する
 * @param {string} fullPath
 */
export function setPostLoginRedirect(fullPath) {
  if (!isSafeRedirectPath(fullPath)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, fullPath);
  } catch (_) {
    // ignore
  }
}

/**
 * 保存済みのリダイレクト先を取り出して削除する。不正な値は null。
 * @param {import('vue-router').Router} router
 * @returns {string | null}
 */
export function consumePostLoginRedirect(router) {
  let raw = null;
  try {
    raw = sessionStorage.getItem(STORAGE_KEY);
  } catch (_) {
    return null;
  }
  if (!raw) return null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // ignore
  }
  if (!isSafeRedirectPath(raw)) return null;
  const resolved = router.resolve(raw);
  if (resolved.path === '/login') return null;
  if (resolved.path.startsWith('/forgot-password')) return null;
  if (resolved.path.startsWith('/password/reset')) return null;
  if (resolved.path.startsWith('/reset-password')) return null;
  return raw;
}
